module.exports = __webpack_public_path__ + "img/business-360-2.221a864f.png";